import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Hook leve que retorna o briefing mais recente por oferta, ja com overlay
 * de human_edits aplicado. Usado no Dashboard para exibir "Proximo passo"
 * direto na OfertaRow sem abrir o OfertaDetailModal.
 *
 * Fonte: deal_context.metadata.briefing_completo + metadata.human_edits.
 *
 * Retorna Map<oferta_id, { proximo_passo, temperatura }>.
 */
export const useBriefingSummaries = () => {
  const [byOferta, setByOferta] = useState(new Map());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('deal_context')
        .select('oferta_id, metadata, created_at')
        .eq('tipo', 'briefing')
        .order('created_at', { ascending: false });

      if (cancelled) return;
      if (error) {
        console.error('[useBriefingSummaries] fetch falhou:', error);
        setByOferta(new Map());
        setLoading(false);
        return;
      }

      // Dedup client-side: 1 briefing por oferta (o mais recente graças ao order).
      const map = new Map();
      for (const row of (data || [])) {
        if (!row.oferta_id || map.has(row.oferta_id)) continue;
        const meta = row.metadata || {};
        const completo = meta.briefing_completo || {};
        const edits = meta.human_edits || {};
        map.set(row.oferta_id, {
          proximo_passo: (edits.proximo_passo !== undefined ? edits.proximo_passo : completo.proximo_passo) || null,
          temperatura: (edits.temperatura !== undefined ? edits.temperatura : completo.temperatura) || null,
        });
      }
      setByOferta(map);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return { byOferta, loading };
};
